module.exports = __webpack_public_path__ + "static/media/Primus-fb.9ce8b51f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/primus/Primus-fb.jpg
// module id = 433
// module chunks = 0